@let active = main();
@let badge = chatBadge();
<nav class="panel-nav-bar">
  @if (canPin()) {
    @let pinLabel = (pinned() ? '1 Column Layout' : '2 Column Layout') | translate;
    <button
      type="button"
      class="pnb-btn pnb-btn--icon"
      [class.pnb-btn--active]="pinned() !== null"
      [attr.aria-pressed]="pinned() !== null"
      [attr.aria-label]="pinLabel"
      [andorTooltip]="pinLabel"
      tooltipPosition="below"
      (click)="togglePin()">
      <fa-duotone-icon [icon]="pinned() ? faWindowMaximize : faTableColumns"></fa-duotone-icon>
    </button>
    <span class="pnb-separator" aria-hidden="true"></span>
  }

  @for (m of modules(); track m.id) {
    @let label = m.label | translate;
    <span class="pnb-item">
      <button
        type="button"
        class="pnb-btn"
        [class.pnb-btn--active]="active === m.id"
        [attr.aria-pressed]="active === m.id"
        [attr.aria-label]="label"
        [andorTooltip]="label"
        tooltipPosition="below"
        (click)="open(m.id)">
        <fa-duotone-icon [icon]="m.icon"></fa-duotone-icon>
        <span class="pnb-label">{{ label }}</span>
      </button>
      @if (m.id === 'chat' && badge) {
        <span class="pnb-badge" [attr.aria-label]="badge + ' unread messages'">{{ badge }}</span>
      }
    </span>
  }
</nav>
